import * as React from "react";
import PropTypes from "prop-types";

type EmptyStateProps = {
  title: string;
  img: React.ReactNode;
  description?: string;
};

const EmptyState: React.FC<EmptyStateProps> = ({ title, img, description }) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {img}
      <div className="tw-text-center">
        <p className="tw-font-semibold">{title}</p>
        {
          description &&
          <p className="tw-text-sm">{description}</p>
        }
      </div>
    </div>
  )
};

EmptyState.propTypes = {
  //
};

export default EmptyState;
